import { gql } from '@apollo/client';

export const USER_CONTACT_INFO_FRAGMENT = gql`
  fragment UserContextUserContactInfo on employee_contact_info {
    email
    login_email
    phone_number
    uuid
  }
`;

export const USER_SUPPLIER_EMPLOYEE_OVERRIDES_FRAGMENT = gql`
  fragment UserContextUserSupplierEmployeeOverrides on supplier_employee_overrides {
    contact_emails
    contact_phone_numbers
    name
    supplier_uuid
    uuid
  }
`;

export const USER_FRAGMENT = gql`
  fragment UserContextUser on employees {
    contact_info {
      ...UserContextUserContactInfo
    }
    locale
    name
    supplier_employee_overrides(
      where: {
        supplier: {
          business_organization_uuid: { _eq: $businessOrganizationUUID }
        }
      }
    ) {
      ...UserContextUserSupplierEmployeeOverrides
      supplier_uuid
    }
    uuid
  }

  ${USER_CONTACT_INFO_FRAGMENT}
  ${USER_SUPPLIER_EMPLOYEE_OVERRIDES_FRAGMENT}
`;

export const USER_QUERY = gql`
  fragment UserContextSupplierEmployee on businesses_employees {
    business_uuid
    employee_config
    employee_permissions
    employee_role
    uuid
  }

  fragment UserContextSupplier on businesses {
    address {
      timezone
      country_code
      uuid
    }
    businesses_employees(where: { employee_uuid: { _eq: $userUUID } }) {
      ...UserContextSupplierEmployee
    }
    name
    payments_status {
      status
    }
    supplier_loyalty_programs {
      uuid
    }
    supplier_metadata {
      app_account_creation_enabled
      display_item_prices
      dynamic_config
      gtin_settings
      uuid
    }
    uuid
  }

  query UserContext_Employee(
    $businessOrganizationUUID: uuid!
    $employeeChatsFilter: employee_chats_bool_exp!
    $userUUID: uuid!
  ) {
    businesses(
      where: {
        type: { _eq: "SUPPLIER" }
        business_organization_uuid: { _eq: $businessOrganizationUUID }
      }
    ) {
      ...UserContextSupplier
    }

    employees_by_pk(uuid: $userUUID) {
      ...UserContextUser
    }

    employee_chats(where: $employeeChatsFilter) {
      app_payments_enabled
      chat_dynamic_config
      chat_uuid
      display_item_prices
      on_hold
      order_review_required
      restaurant_account_id
      restaurant_address
      restaurant_employee_role
      restaurant_name
      restaurant_timezone
      restaurant_uuid
      show_app_payments_tab
      status
      supplier_uuid
    }

    whitelabel_config(
      where: { business_organization_uuid: { _eq: $businessOrganizationUUID } }
    ) {
      translations_enabled
      uuid
    }
  }

  ${USER_FRAGMENT}
`;
